document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("CollectionSearchInput");
  const gridContainer = document.querySelector("#ProductGridContainer");

  if (!input || !gridContainer) return;

  let timeout;

  input.addEventListener("input", function () {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      const query = input.value.trim();

      if (!query) return;

      // loader
      gridContainer.style.opacity = "0.5";

      fetch(`/search?q=${encodeURIComponent(query)}&type=product`)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");

          const newGrid = doc.querySelector("#product-grid, .product-grid, ul.grid");

          if (newGrid) {
            document.querySelector("#product-grid").innerHTML = newGrid.innerHTML;
          }

          gridContainer.style.opacity = "1";
        })
        .catch(() => {
          gridContainer.style.opacity = "1";
        });

    }, 400);
  });
});